'use strict';

import BaseService from './base.service';

class CreditorsService extends BaseService {
  /* @ngInject */
  constructor(Creditor, SegaUser) {
    super(Creditor, SegaUser);
    Object.assign(this, {
      Creditor
    });
  }
}

export default CreditorsService;
